<template>
    <div :class="{ 'app-dark-theme': isDarkTheme() }">

        <!-- Titlebar
        ================================================== -->

        <div  class="bg_img_top static_page_bg" v-bind:style="{backgroundImage: faq_data[0].image && faq_data[0].show_banner_image == 'yes' ? 'url('+ faq_data[0].image +')' : 'url('+ webUrl+ 'assets/images/faq-bg.webp)'}" v-if="!isAppView()">

        <!-- <div id="titlebar" class="gradient signup_mrgn faq_mrgn"> -->
            <div class="full_gragient">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="text-center faq_haed" v-html="faq_data[0].title"></h1>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div :class="isAppView() ? 'mt-0' : 'margin-top-50 mobile_tab_margin_top_35'"></div>
    <!-- Page Content
        ================================================== -->
        <div class="container faq_container_web">
            <div class="row">
                <div class="col-xl-12 common_block">
                    <!-- <div class="selected_faq_radio">
                        <input type="radio" v-model="x" value="jobseeker"><span class="first_span_radio">Job Seekers</span>
                        <input type="radio" v-model="x" value="hirers"><span>Hirers</span>
                    </div> -->
                    <div class="toggle_div_main_faq" :class="isAppView ? 'mobile_tg' : ''">
                        <div class="toggle_wrapper_faq" v-if="!isAppView()">
                            <!-- {{tab_type}} -->
                            <div class="toggle_group_faq">
                                <label :class="['toggle_option_faq', { active: x === 'jobseeker' }]">
                                <input type="radio" v-model="x" value="jobseeker" @change="tab_type='Employee';resetValues();getWebsiteData()"/>
                                {{ $t('faq.tab_jobseekers') }}
                                </label>

                                <label :class="['toggle_option_faq', { active: x === 'hirers' }]">
                                <input type="radio" v-model="x" value="hirers" @change="tab_type='Employer';resetValues();getWebsiteData()"/>
                                {{ $t('faq.tab_hirers') }}
                                </label>
                            </div>
                        </div>
                        <div class="langauage_filter_select">
                            <!-- FAQ content languages come from the country profile
                                 (config/countries.js — faqLanguages). -->
                            <b-form-select v-model="language" @change="updateLanguageQuery" class="button custom-select ripple-effect">
                                <option v-for="l in $profile.faqLanguages" :key="l.value" :value="l.value">{{ l.label }}</option>
                            </b-form-select>
                            <span class="select_arrow_faq material-icons-outlined">expand_more_outlined</span>
                        </div>
                    </div>

                    <!-- <div v-show="x === 'one'">One</div>
                    <div v-show="x === 'two'">Two</div> -->



                    <div v-if="faqs" class="">
                        <div v-show="x === 'jobseeker'">
                            <!-- <div class="form-head mb-3 text-center">
                                <h4 class="golden-text"><b>Job Seekers</b></h4>
                            </div> -->
                            <div class="row faq_reverse">
                                <div class="col-xl-7 col-md-7">
                                    <p class="top_q_head">{{ $t('faq.top_questions') }}</p>
                                    <div class="faq-content-box clearfix faq_paragraph question_section_toggle" v-if="faqs.length > 0">
                                        <div v-for="(faq,key) in faqs" :key="faq.id + '-' + currentPage">
                                            <div class="accordion-listing-box max_width_hundered">
                                                <b-card no-body v-if="faq.faq_type == 'Employee'">
                                                    <b-card-header header-tag="header" role="tab" :class="openItemJobseeker === faq.id ? 'has_bg_for_head' : 'no_bg_for_head'">
                                                        <b-button v-b-toggle="'accordion-'+faq.id" class="m-1" variant="info"><span class="question_span">{{ $t('faq.q_prefix') }} {{ questionText(faq) }}</span>
                                                            <span  class="material-icons-outlined plus_minus_icon_faq">
                                                                {{ openItemJobseeker === faq.id ? 'remove_outlined' : 'add_outlined' }}
                                                            </span>
                                                        </b-button>
                                                    </b-card-header>
                                                    <b-collapse
                                                        :id="'accordion-'+faq.id"
                                                        accordion="my-accordion"
                                                        role="tabpanel"
                                                        @show="openItemJobseeker = faq.id"
                                                        @hide="onHide(faq.id)">
                                                        <b-card-body :class="openItemJobseeker === faq.id ? 'has_bg_for_head' : 'no_bg_for_head'">
                                                            <!-- <b-card-text v-if="faq.url"><p><a :href="faq.url" target="_blank">{{faq.answer}}</a></p></b-card-text>
                                                            <b-card-text v-else><p>{{faq.answer}}</p></b-card-text> -->
                                                            <div class="card-text" v-html="answerText(faq)"></div>

                                                            <!-- Helpful widget -->
                                                            <div class="helpful-widget">
                                                                <div class="helpful-question">{{ $t('faq.helpful_question') }}</div>

                                                                <div class="helpful-actions helpful_actions_training">
                                                                    <b-button
                                                                        class="helpful-btn"
                                                                        :class="{ active: vote[faq.id] === 'yes' }"
                                                                        :disabled="locked[faq.id] === true || submitting[faq.id] === true"
                                                                        variant="outline-primary"
                                                                        @click="onHelpfulVote(faq.id, 'yes')"
                                                                    >
                                                                        <span class="ico">✓</span> {{ $t('faq.yes') }}
                                                                    </b-button>

                                                                    <b-button
                                                                        class="helpful-btn"
                                                                        :class="{ active: vote[faq.id] === 'no' }"
                                                                        :disabled="locked[faq.id] === true || submitting[faq.id] === true"
                                                                        variant="outline-primary"
                                                                        @click="onHelpfulVote(faq.id, 'no')"
                                                                    >
                                                                        <span class="ico">×</span> {{ $t('faq.no') }}
                                                                    </b-button>
                                                                </div>

                                                                <div class="helpful-stats">
                                                                    {{ $t('faq.helpful_stats', { positive: (positive_feedback_count[faq.id] || 0), total: (total_feedback_count[faq.id] || 0) }) }}
                                                                </div>
                                                                <!-- <div class="question_note_training mt-4">
                                                                    <p>Have more questions? <b-link :to="{ name: 'ContactUs', query: { app: 'yes' } }">Submit a request</b-link></p>
                                                                </div> -->
                                                                <div v-if="locked[faq.id]" class="helpful-thanks mt-1">
                                                                    {{ $t('faq.helpful_thanks') }}
                                                                </div>
                                                            </div>

                                                        </b-card-body>
                                                    </b-collapse>
                                                </b-card>

                                            </div>
                                        </div>
                                         <nav class="pagination-box custom_pagination_border_radius common_pagination_nw">
                                            <div class="page-row-box d-inline-block">
                                                <b-form-group id="input-group-4">
                                                    <span class="d-inline-block">{{ $t('jobs.rows_per_page') }}</span>
                                                    <span class="d-inline-block">
                                                   <b-form-select
                                                    v-model="form.rowsPerPage"
                                                    @change="onRowsPerPageChange"
                                                    >
                                                    <option :value="6">6</option>
                                                    <option :value="12">12</option>
                                                    <option :value="18">18</option>
                                                    <option :value="24">24</option>
                                                    </b-form-select></span>
                                                </b-form-group>
                                            </div>
                                            <div class="total-page-count d-inline-block">
                                                <ul>
                                                    <li>
                                                        <span v-if='totalRows != 0'>{{from}} - {{to}} {{ $t('faq.of') }} {{totalRows}}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <!-- <b-pagination @change="getWebsiteData()" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="" next-text="" hide-goto-end-buttons /> -->
                                            <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                                hide-goto-end-buttons
                                                @change="onPageChange"
                                                prev-text="" next-text=""
                                                :limit="3"
                                                />
                                        </nav>
                                    </div>
                                    <div  v-else>
                                        <p class="margin_top_1rem" style="text-align:center;"><b>{{ $t('jobs.no_record_found') }}</b> </p>
                                    </div>
                                </div>
                                <!-- <div class="col-xl-5 col-md-5"> -->
                                    <!-- <div class="col-xl-12 col-md-12"> -->
                                <div class="col-xl-5 col-md-5">
                                    <div  class="faq_img_right">
                                        <img :src="webUrl+'/assets/images/icon-2.webp'" alt="faq jobseeker">
                                    </div>
                                     <center class="mobile_start_section">
                                        <h2 class="faq_h2_web">
                                            {{ $t('faq.any_question') }}
                                        </h2>

                                        <h4 class="faq_h4_web">
                                            {{ $t('faq.need_help') }}
                                        </h4>
                                        <div class="single_search_web faq_search">
                                            <input type="text" class="" :placeholder="$t('faq.ph_search_question')" v-model="filter" v-on:change="getWebsiteData">
                                            <b-button @click="getWebsiteData" class="search_faq_btn_web"><i class="fa fa-search common_bg_white"></i></b-button>
                                        </div>
                                        <p class="contact_p_web mb-0">{{ $t('faq.cant_find') }} <b-link :to="{name:'ContactUs', query: $route.query.app ? { app: $route.query.app} : {} }">{{ $t('faq.support_team') }}</b-link></p>


                                    </center>

                                </div>
                            </div>
                            <!-- </div> -->




                        </div>
                        <!-- <br> -->
                        <div v-show="x === 'hirers'">
                            <!-- <div class="form-head mb-3 text-center">
                                <h4 class="golden-text"><b>Hirers</b></h4>
                            </div> -->
                            <!-- <div class="col-xl-5 col-md-5"> -->
                            <div class="row">
                            <div class="col-xl-5 col-md-5">
                                <div  class="faq_img_right">
                                    <img :src="webUrl+'/assets/images/faq-1.webp'" alt="faq hirer">
                                </div>
                                <center class="mobile_start_section">
                                    <h2 class="faq_h2_web">
                                            {{ $t('faq.any_question') }}
                                    </h2>

                                    <h4 class="faq_h4_web">
                                        {{ $t('faq.need_help') }}
                                    </h4>
                                    <div class="single_search_web faq_search">
                                        <input type="text" class="" :placeholder="$t('faq.ph_search_question')" v-model="filter" v-on:change="getWebsiteData">
                                        <b-button @click="getWebsiteData" class="search_faq_btn_web"><i class="fa fa-search common_bg_white"></i></b-button>
                                    </div>
                                    <p class="contact_p_web mb-0">{{ $t('faq.cant_find') }} <b-link :to="{name:'ContactUs', query: $route.query.app ? { app: $route.query.app} : {} }">{{ $t('faq.support_team') }}</b-link></p>
                                </center>
                            </div>
                            <!-- </div> -->

                            <!-- <div class="col-md-2">
                                <b-form-select v-model="language" @change="updateLanguageQuery" class="button button-sliding-icon ripple-effect">
                                    <option value="en">English</option>
                                    <option value="zh">Chinese</option>
                                    <option value="ms">Malay</option>
                                    <option value="ta">Tamil</option>
                                </b-form-select>
                            </div> -->
                            <div class="col-xl-7 col-md-7">
                            <p class="top_q_head">{{ $t('faq.top_questions') }}</p>
                            <div class="faq-content-box clearfix faq_paragraph question_section_toggle" v-if="faqs.length > 0">
                                <div v-for="(faq,key) in faqs" :key="faq.id + '-' + currentPage">
                                    <div class="accordion-listing-box max_width_hundered">

                                        <b-card no-body v-if="faq.faq_type == 'Employer'">
                                            <b-card-header header-tag="header" role="tab" :class="openItemHirer === faq.id ? 'has_bg_for_head' : 'no_bg_for_head'">
                                                <b-button v-b-toggle="'accordion-'+faq.id" class="m-1" variant="info"><span class="question_span">{{ $t('faq.q_prefix') }} {{ questionText(faq) }}</span>
                                                    <span  class="material-icons-outlined plus_minus_icon_faq">
                                                        {{ openItemHirer === faq.id ? 'remove_outlined' : 'add_outlined' }}
                                                    </span>
                                                </b-button>
                                            </b-card-header>
                                            <b-collapse
                                                :id="'accordion-'+faq.id"
                                                accordion="my-accordion"
                                                role="tabpanel"
                                                @show="openItemHirer = faq.id"
                                                @hide="onHide(faq.id)"
                                            >
                                                <b-card-body :class="openItemHirer === faq.id ? 'has_bg_for_head' : 'no_bg_for_head'">
                                                    <!-- <b-card-text v-if="faq.url"><p><a :href="faq.url" target="_blank">{{faq.answer}}</a></p></b-card-text>
                                                    <b-card-text v-else><p>{{faq.answer}}</p></b-card-text> -->
                                                    <div class="card-text" v-html="answerText(faq)"></div>

                                                    <!-- Helpful widget -->
                                                    <div class="helpful-widget">
                                                        <div class="helpful-question">{{ $t('faq.helpful_question') }}</div>

                                                        <div class="helpful-actions helpful_actions_training">
                                                            <b-button
                                                                class="helpful-btn"
                                                                :class="{ active: vote[faq.id] === 'yes' }"
                                                                :disabled="locked[faq.id] === true || submitting[faq.id] === true"
                                                                variant="outline-primary"
                                                                @click="onHelpfulVote(faq.id, 'yes')"
                                                            >
                                                                <span class="ico">✓</span> {{ $t('faq.yes') }}
                                                            </b-button>

                                                            <b-button
                                                                class="helpful-btn"
                                                                :class="{ active: vote[faq.id] === 'no' }"
                                                                :disabled="locked[faq.id] === true || submitting[faq.id] === true"
                                                                variant="outline-primary"
                                                                @click="onHelpfulVote(faq.id, 'no')"
                                                            >
                                                                <span class="ico">×</span> {{ $t('faq.no') }}
                                                            </b-button>
                                                        </div>

                                                        <div class="helpful-stats">
                                                            {{ $t('faq.helpful_stats', { positive: (positive_feedback_count[faq.id] || 0), total: (total_feedback_count[faq.id] || 0) }) }}
                                                        </div>
                                                        <!-- <div class="question_note_training mt-4">
                                                            <p>Have more questions? <b-link :to="{ name: 'ContactUs' }">Submit a request</b-link></p>
                                                        </div> -->
                                                        <div v-if="locked[faq.id]" class="helpful-thanks mt-1">
                                                            {{ $t('faq.helpful_thanks') }}
                                                        </div>
                                                    </div>

                                                </b-card-body>
                                            </b-collapse>
                                        </b-card>
                                    </div>
                                </div>
                                 <nav class="pagination-box custom_pagination_border_radius common_pagination_nw">
                                    <div class="page-row-box d-inline-block">
                                        <b-form-group id="input-group-4">
                                            <span class="d-inline-block">{{ $t('jobs.rows_per_page') }}</span>
                                            <span class="d-inline-block">
                                            <b-form-select
                                                v-model="form.rowsPerPage"
                                                @change="onRowsPerPageChange"
                                                >
                                                <option :value="6">6</option>
                                                <option :value="12">12</option>
                                                <option :value="18">18</option>
                                                <option :value="24">24</option>
                                                </b-form-select></span>
                                        </b-form-group>
                                    </div>
                                    <div class="total-page-count d-inline-block">
                                        <ul>
                                            <li>
                                                <span v-if='totalRows != 0'>{{from}} - {{to}} {{ $t('faq.of') }} {{totalRows}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="" next-text="" hide-goto-end-buttons /> -->
                                    <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        hide-goto-end-buttons
                                        @change="onPageChange"
                                        prev-text="" 
                                        next-text=""
                                        :limit="3"
                                        />
                                </nav>
                            </div>
                            <div v-else>
                                <p class="margin_top_1rem" style="text-align:center;"><b>{{ $t('jobs.no_record_found') }}</b> </p>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Spacer -->
        <div class="margin-top-50 mobile_tab_margin_top_35"></div>
        <!-- Spacer / End-->
    </div>
</template>


<script>
import { POST_API } from '../../store/actions.type';
import { getMetaInfo } from '@/seo.config';
import { getFAQSchemaFromList, injectJsonLd } from '@/schema.config';
import { Carousel, Slide } from 'vue-carousel';
import VueSlickCarousel from 'vue-slick-carousel'
import moment from 'moment'

export default{
    metaInfo() { return getMetaInfo('/faq'); },
    data() {
        return {
            pager: {},
            pageOfItems: [],
            items:null,
            totalRows: 0,
            from: '',
            to: '',
            currentPage: 1,
            perPage: 6,
            pageOptions: [6, 12, 18, 24],
            sortBy: null,
            sortDirection: 'asc',
            filter: '',
            form:{
                rowsPerPage:6,
            },

            tab_type: 'Employee',
            forcedFromUrl: false,
            openItemJobseeker: null,
            openItemHirer: null,
            x: 'jobseeker',
            webUrl:process.env.VUE_APP_URL,
			banners:[],
			faqs:[],
            faq_data:[],
			process_descriptions:[],
			partners:[],
			promotions:[],
			jobs:[],
			filter:'',
            // Default = first FAQ language of the country profile (SG: en, TH: th).
            language: (this.$profile.faqLanguages[0] || {}).value || 'en',
            vote: {},          // { [articleId]: 'yes' | 'no' | null }
            locked: {},        // { [articleId]: true | false } // stop re-vote
            submitting: {},    // { [articleId]: true | false } // button spinner/disable
            positive_feedback_count: {},
            total_feedback_count: {},
			tagArray:[],
			BackImage: 'url(/assets/images/home-background.webp)',
			settings: {
				"slidesToShow": 2,
				"slidesToScroll": 2,
				"speed": 800,
				"infinite": false,
				responsive: [
					{
					breakpoint: 768,
					settings: {
						"slidesToShow": 1,
							"slidesToScroll": 1,
							"speed": 800,
							"infinite": false
					}
					}
				]
			}
        }
    },
    // computed: {
    //     isAppView() {
    //         return ['jobseeker', 'employer'].includes(this.$route.query.app)
    //     }
    // },
	components: {
        VueSlickCarousel,
        Carousel,
        Slide
    },
	filters: {
            capitalize: function(value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            },

            customFormatterOne(date) {
                return moment(date).utc().format('DD-MM-YYYY');
            },

            removeUnderscore: function(value) {
                if (!value) return ''
                var i, frags = value.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
    },
	methods:{
        resetValues(){
            this.openItemJobseeker = null
            this.openItemHirer = null
            this.pager = {}
            this.pageOfItems = []
            this.items = null,
            this.totalRows = 0
            this.from = ''
            this.to = ''
            this.currentPage = 1
            this.perPage = 6
            this.sortBy = null
            this.sortDirection = 'asc'
            this.form.rowsPerPage = 6
        },
        onRowsPerPageChange() {
            this.currentPage = 1 ;   
            this.openItemJobseeker = null
            this.openItemHirer = null
            this.getWebsiteData()
        },
         onPageChange(page) {
            this.currentPage = page
            this.openItemJobseeker = null
            this.openItemHirer = null
            this.getWebsiteData()
        },
        onHide(id) {
            if (this.openItemHirer === id) {
                this.openItemHirer = null
            }
            if (this.openItemJobseeker === id) {
                this.openItemJobseeker = null
            }
        },
        applyTabFromUrl() {
            const app = this.$route.query.app
            const tab = this.$route.query.tab

            if (app === 'employer') {
                this.x = 'hirers'
                this.forcedFromUrl = true
            } else if (app === 'jobseeker') {
                this.x = 'jobseeker'
                this.forcedFromUrl = true
            } else if (tab === 'employer') {
                this.x = 'hirers'
            } else if (tab === 'jobseeker') {
                this.x = 'jobseeker'
            }
        },
        ensureVoterId() {
            // anonymous device id; persists across refreshes
            const KEY = 'helpful_voter_id';
            let id = localStorage.getItem(KEY);
            if (!id) {
                // a light UUID-ish id is fine here
                id = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,c=>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                );
                localStorage.setItem(KEY, id);
            }
            this.voterId = id;
        },
        onHelpfulVote(id, choice) {
            // One vote per device: block if locked or already same choice
            if (this.locked[id] === true) return;

            this.$set(this.submitting, id, true);

            // call API (server calculates + enforces uniqueness)
            this.$store.dispatch(POST_API, {
                data: {
                    faqId: id,
                    vote: choice,
                    voterId: this.voterId
                },
                api: '/api/faq-feedback-update'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;

                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: this.error_message,
                        showConfirmButton: false,
                        timer: 1500
                    });

                } else {
                    // server returns canonical counts + stored vote
                    const { storedVote, positive_count, total_count } = this.$store.getters.getResults.data;

                    console.log(storedVote, positive_count, total_count);

                    // update UI from server truth
                    this.$set(this.vote, id, storedVote ?? choice);
                    if (typeof positive_count === 'number') {
                        this.$set(this.positive_feedback_count, id, positive_count);
                    }
                    if (typeof positive_count === 'number') {
                        this.$set(this.total_feedback_count, id, total_count);
                    }
                    this.$set(this.locked, id, true);
                }
                this.$set(this.submitting, id, false);
            });
        },
        FaqStaticData(){
                 return this.$store.dispatch(POST_API, {
                    data:{
                        token: this.email,
                    },
                    api:'/api/faq-static-data'
                })
                .then(() => {
                    if (this.$store.getters.containsErrors) {
                        this.error_message = this.$store.getters.getErrors;

                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: this.error_message,
                            showConfirmButton: false,
                            timer: 1500
                        });

                    } else {
                        this.faq_data = this.$store.getters.getResults.faq_data;
                    }
            })

            },
		getWebsiteData() {
            return this.$store.dispatch(POST_API, {
				data:{
                    keyword: this.filter,
                    type: this.tab_type,
                    page: this.currentPage,
                    rowsPerPage:this.form.rowsPerPage,
                },
                api: '/api/faq'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    // this.showAlert();
                    return [];
                } else {
                    this.faqs = this.$store.getters.getResults.data;
                    this.totalRows = this.$store.getters.getResults.pager.totalItems;
                    this.perPage = this.$store.getters.getResults.pager.pageSize;
                    // this.perPage = this.form.rowsPerPage;
                    this.from = this.$store.getters.getResults.pager.from;
                    this.to = this.$store.getters.getResults.pager.to;

                    // ✅ initialize vote mapping once data arrives
                    this.faqs.forEach(t => {
                        if (this.vote[t.id] === undefined) this.$set(this.vote, t.id, null);
                        if (this.locked[t.id] === undefined) this.$set(this.locked, t.id, false);
                        if (this.submitting[t.id] === undefined) this.$set(this.submitting, t.id, false);
                    });

                    // fetch vote status + latest counts for all shown articles (bulk)
                    const ids = this.faqs.map(t => t.id);
                    if (ids.length) {
                        this.$store.dispatch(POST_API, {
                            data: {
                                faqIds: ids,
                                voterId: this.voterId
                            },
                            api: '/api/faq-feedback'
                        })
                        .then(() => {
                            if (this.$store.getters.containsErrors) {
                                this.error_message = this.$store.getters.getErrors;
                                // this.showAlert();
                                return [];
                            } else {
                                const rows = this.$store.getters.getResults.data;
                                rows.forEach(row => {
                                    this.$set(this.vote, row.faq_id, row.user_vote ?? null);
                                    this.$set(this.locked, row.faq_id, row.user_vote ? true : false); // lock if already voted
                                    this.$set(this.positive_feedback_count, row.faq_id, row.positive_count ?? 0);
                                    this.$set(this.total_feedback_count, row.faq_id, row.total_count ?? 0); // lock if already voted
                                });
                            }
                        })
                    }

                    /* // Remove old FAQ schema if any
                    document.querySelectorAll('script[type="application/ld+json"]').forEach(el => {
                        if (el.textContent.includes('"@type":"FAQPage"')) {
                            el.parentNode.removeChild(el);
                        }
                    });
                    // Inject fresh FAQ schema
                    this.injectFAQSchema(); */

                    return this.faqs;
                }
            });
        },
		// getJobData() {
        //     return this.$store.dispatch(POST_API, {
		// 		data:{
        //             keyword: this.filter,
        //         },
        //         api: '/api/job-data'
        //     })
        //     .then(() => {
        //         if (this.$store.getters.containsErrors) {
        //             this.error_message = this.$store.getters.getErrors;
        //             // this.showAlert();
        //             return [];
        //         } else {
        //             this.jobs = this.$store.getters.getResults.jobs;

        //         }
        //     });
        // },


        injectFAQSchema() {
            injectJsonLd('faq-schema-page', getFAQSchemaFromList(this.faqs));
        },
        questionText(faq) {
            switch (this.language) {
                case 'en':
                return faq.question;
                case 'zh':
                return faq.question_zh;
                case 'ms':
                return faq.question_ms;
                case 'ta':
                return faq.question_ta;
                case 'th':
                return faq.question_th || faq.question;
                default:
                return faq.question;
            }
        },
        answerText(faq) {
            switch (this.language) {
                case 'en':
                return faq.answer;
                case 'zh':
                return faq.answer_zh;
                case 'ms':
                return faq.answer_ms;
                case 'ta':
                return faq.answer_ta;
                case 'th':
                return faq.answer_th || faq.answer;
                default:
                return faq.answer;
            }
        },
        updateLanguageQuery() {
            // 3) Merge with existing query params and update the URL
            this.$router.push({
                query: {
                    ...this.$route.query,
                    language: this.language
                }
            })
        },
	},
   watch: {
        '$route': {
            immediate: true,
            handler(to) {
            console.log(
                'Route changed. app =',
                to.query.app,
                'language =',
                to.query.language
            )

            /* ---------- language logic (existing) ---------- */
            if (to.query.language && to.query.language !== this.language) {
                this.language = to.query.language
            }

            /* ---------- TAB SWITCH LOGIC (NEW) ---------- */
            if (to.query.app === 'employer') {
                this.x = 'hirers'
                this.tab_type = 'Employer'
            } else if (to.query.tab === 'employer') {
                this.x = 'hirers'
                this.tab_type = 'Employer'
            } else if (to.query.app === 'jobseeker') {
                this.x = 'jobseeker'
                this.tab_type = 'Employee'
            } else if (to.query.tab === 'jobseeker') {
                this.x = 'jobseeker'
                this.tab_type = 'Employee'
            }
            // else → /faq (do nothing)
            }
        }
    },
    created() {
        // 1) Initialize from URL if present
        const langFromQuery = this.$route.query.language
        if (langFromQuery) this.language = langFromQuery

        this.ensureVoterId();
        this.applyTabFromUrl()
    },
	mounted(){
            window.scrollTo(0,0);
            // this.getJobData();
            //document.title = "EL Connect - Faq";
            Promise.all([
                this.faqs.length     ? Promise.resolve() : this.getWebsiteData(),
                this.faq_data.length ? Promise.resolve() : this.FaqStaticData(),
            ]).finally(() => {
                document.dispatchEvent(new Event('x-app-rendered'));
            });
    }
}


</script>

<style scoped>
/* Dark mode for the app webview only — driven by ?theme=dark in the URL (isDarkTheme()),
   not by the device/WebView's own forced-dark heuristic, which gave broken/washed-out
   contrast (white cards, near-invisible text). */
.app-dark-theme {
    background: #121212;
}
.app-dark-theme ::v-deep .faq_h2_web,
.app-dark-theme ::v-deep .faq_h4_web,
.app-dark-theme ::v-deep .top_q_head,
.app-dark-theme ::v-deep .contact_p_web,
.app-dark-theme ::v-deep .total-page-count,
.app-dark-theme ::v-deep .question_span,
.app-dark-theme ::v-deep .card-text,
.app-dark-theme ::v-deep .helpful-question,
.app-dark-theme ::v-deep .helpful-stats {
    color: #e0e0e0 !important;
}
.app-dark-theme ::v-deep .no_bg_for_head,
.app-dark-theme ::v-deep .has_bg_for_head,
.app-dark-theme ::v-deep .card,
.app-dark-theme ::v-deep .card-body {
    background: #1e1e1e !important;
    color: #e0e0e0 !important;
    border-color: #333 !important;
}
.app-dark-theme ::v-deep .single_search_web input,
.app-dark-theme ::v-deep .single_search_web select {
    background: #1e1e1e !important;
    color: #e0e0e0 !important;
    border-color: #444 !important;
}
.app-dark-theme ::v-deep .single_search_web input::placeholder {
    color: #999 !important;
}
.app-dark-theme ::v-deep .langauage_filter_select select,
.app-dark-theme ::v-deep .page-row-box select {
    background: #1e1e1e !important;
    color: #e0e0e0 !important;
    border-color: #444 !important;
}
.app-dark-theme ::v-deep .toggle_option_faq {
    color: #e0e0e0 !important;
}
.app-dark-theme ::v-deep .page-item .page-link {
    background: #1e1e1e !important;
    color: #e0e0e0 !important;
    border-color: #444 !important;
}
</style>
